import React from "react";
import { Spin, Icon } from "antd";
import "./LoadingIndicator.less";

type Props = {
    detailed?: boolean,
    text?: string,
    subTitle?: string,
    style?: React.CSSProperties
};

const LoadingIndicator = ({ detailed, text, subTitle, style }: Props) => {
    return (
        <div
            className={detailed ? "detailed-loading-indicator" : "simple-loading-indicator"}
            style={style ? style : {}}>
            {detailed ? (
                <>
                    <Spin indicator={<Icon type="loading-3-quarters" spin />} />
                    <h2>{text}</h2>
                    <div className="sub-title">{subTitle}</div>
                </>
            ) : (
                <Spin indicator={<Icon type="loading-3-quarters" spin />} />
            )}
        </div>
    );
};

export default LoadingIndicator;
